import React from 'react';

const RefundPolicy = () => {
  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')` }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Cancellation / Refund Policy</h1>
          </div>
        </div>
      </div>

      <div className="row justify-content-center p-5">
        <div className="col-lg-12">
          <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
            <div className="media-body">
              <h3 className="box-title">Cancellation / Refund Policy</h3>
              <p className="box-text" style={{ maxWidth: '100%', textAlign: 'left', paddingRight: '20px' }}>
                <strong>1. Scope </strong> <br />
                This policy applies to all bookings made on <a href="https://www.hariharapura.in">www.hariharapura.in</a> for seva, accommodation (rooms/guest house), or other services. <br /> <br />
                
                <strong>2. Room / Accommodation Booking – No Cancellation and No Refund </strong> <br />
                • <strong>All room/guest-house bookings are strictly non-cancellable, non-modifiable, and non-refundable. </strong> <br />
                • Once a booking is confirmed and payment is completed, <strong> no refund </strong> will be issued <strong> under any circumstances, </strong> including but not limited to: <br />
                &nbsp; &nbsp;  o Change of travel plans <br />
                &nbsp; &nbsp;  o Personal reasons <br />
                &nbsp; &nbsp;  o Mistaken bookings <br />
                &nbsp; &nbsp;  o Late arrival or early departure <br />
                &nbsp; &nbsp;  o No-show on the booking date <br />
                • Guests are requested to carefully check the dates, room type, and number of guests before confirming the booking. <br /> <br />

                <strong>3. Seva / Other Bookings (If Applicable) </strong> <br />
                If you offer seva or other bookable options, you can choose one of the below: <br />
                <strong> Also Strictly Non-Refundable: </strong> <br />
                “All seva and associated bookings are also non-cancellable and non-refundable.” <br /> <br />

                <strong>4. No-Show Policy </strong> <br />
                • If the guest does not arrive on the scheduled check-in date, the booking will be treated as a <strong> no-show, </strong> and <strong> no refund </strong> will be provided.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
